import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDollar2Fill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.9978 16.368V13.222C13.8588 13.231 14.5558 13.93 14.5558 14.79C14.5558 15.655 13.8588 16.359 12.9978 16.368ZM9.44385 9.54C9.44385 8.661 10.1308 7.947 10.9978 7.882V11.208C10.1318 11.143 9.44385 10.424 9.44385 9.54ZM16.5558 14.79C16.5558 12.827 14.9608 11.231 12.9978 11.222V7.87H13.3378C14.0088 7.87 14.5548 8.413 14.5548 9.08V9.209C14.5548 9.762 15.0028 10.209 15.5548 10.209C16.1068 10.209 16.5548 9.762 16.5548 9.209V9.08C16.5548 7.31 15.1118 5.87 13.3378 5.87H12.9978V5C12.9978 4.447 12.5498 4 11.9978 4C11.4458 4 10.9978 4.447 10.9978 5V5.882C9.02785 5.949 7.44385 7.558 7.44385 9.541C7.44485 11.527 9.02985 13.141 10.9978 13.208V16.37H10.6618C9.99085 16.37 9.44585 15.823 9.44585 15.15C9.44585 14.597 8.99785 14.15 8.44585 14.15C7.89385 14.15 7.44585 14.597 7.44585 15.15C7.44585 16.925 8.88885 18.37 10.6618 18.37H10.9978V19C10.9978 19.552 11.4458 20 11.9978 20C12.5498 20 12.9978 19.552 12.9978 19V18.368C14.9608 18.359 16.5558 16.758 16.5558 14.79Z",
		fill: "currentColor"
	})
});
export default SvgDollar2Fill;
